<template>
  <div class="d-flex flex-column gke-container">
    <div class="line-separator" />
    <div class="d-flex cloud-menu">
      <RexSearchSelect
        :current="currentGKECluster"
        :data="gkeClusters"
        width="14.875rem"
        @onChoose="(item) => onClusterChange(item)"
        :heading="this.$t('selectCluster')"
        :objectValueIndex="1"
        id="search-select-cloud-cluster"
      />

      <RexSearchSelect
        v-if="currentTab.key != 'nodes'"
        :current="currentGKENamespace"
        :data="gkeNamespaces"
        width="14.875rem"
        @onChoose="(item) => onNamespaceChange(item)"
        :heading="this.$t('selectNamespace')"
        :objectValueIndex="1"
        id="search-select-cloud-cluster-namespace"
      />
    </div>
    <NavTabDynamic
      class="navtab"
      :active="currentTab"
      @redirectInput="redirectTab"
      :data="getNavtabs"
    />
    <!-- <component :is="currentView"></component> -->
    <router-view></router-view>
  </div>
</template>
<script>
/**
 * @author Tarun Rawat
 * Desc: Common Componet for GKE Tabs: Nodes,Container and Pods.
 * TODO : Please handle undefined action !
 */
import NavTabDynamic from '../../../../Main/TheNavTabDynamic.vue';
import { GKE_TABS, GKE_TABS_NAVBAR } from '../../util';
import { components } from '../../k8';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import {
  SET_CURRENT_GKE_TAB,
  GET_GKE_NAMESPACES,
  SET_CURRENT_GKE_NAMESPACE,
} from '../../../../../store/modules/cloud/services/cloud.constant';
import { permissionTypes } from '@/router/constant';

export default {
  name: 'GKE',
  components: { NavTabDynamic, ...components, RexSearchSelect },
  data() {
    return {
      currentTab: {},
      currentView: GKE_TABS.NODE,
    };
  },
  computed: {
    ...mapState('globalState/app', ['chartsTemplate']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapGetters('globalState/user', ['getTeamId']),
    ...mapState('cloudState/services', [
      'gkeClusters',
      'gkeNamespaces',
      'currentGKECluster',
      'currentGKENamespace',
      'cloudSvc',
      'currentGkeTab',
    ]),
    getNavtabs() {
      return this.chartsTemplate?.GKE?.navItems || [];
    },
  },
  methods: {
    ...mapMutations('cloudState/services', [
      'setCurrentGKECluster',
      SET_CURRENT_GKE_NAMESPACE,
    ]),
    ...mapActions('cloudState/services', [
      'GET_GKE_CLUSTERS',
      GET_GKE_NAMESPACES,
      SET_CURRENT_GKE_TAB,
    ]),
    redirectTab(tab) {
      this.currentTab = tab;
      this.currentView = tab.key.toUpperCase();
      this.SET_CURRENT_GKE_TAB(this.currentView);
      this.$router.push({ name: tab.key.toLowerCase() });
    },
    onClusterChange(value) {
      this.setCurrentGKECluster(value);
      this.GET_GKE_NAMESPACES({
        duration: this.getDurationTime,
        teamId: this.getTeamId,
      });
    },
    onNamespaceChange(value) {
      this[SET_CURRENT_GKE_NAMESPACE](value);
    },
  },
  mounted() {
    this.GET_GKE_CLUSTERS({
      duration: this.getDurationTime,
      permissions: [permissionTypes.READ, permissionTypes.WRITE],
    })?.then(() => {
      this.GET_GKE_NAMESPACES({
        duration: this.getDurationTime,
        teamId: this.getTeamId,
      });
    });
  },
  watch: {
    cloudSvc() {
      this.GET_GKE_CLUSTERS({
        duration: this.getDurationTime,
        permissions: [permissionTypes.READ, permissionTypes.WRITE],
      })?.then(() => {
        this.GET_GKE_NAMESPACES({
          duration: this.getDurationTime,
          teamId: this.getTeamId,
        });
      });
    },
    currentGkeTab() {
      if (!this.currentGKENamespace)
        this.GET_GKE_NAMESPACES({
          duration: this.getDurationTime,
          teamId: this.getTeamId,
        });
    },
  },
  created() {
    const currentRoute = this.$route.name.toUpperCase();
    if (GKE_TABS_NAVBAR[currentRoute] === undefined)
      this.currentTab = { label: this.$t('nodes'), key: 'nodes' };
    else this.currentTab = GKE_TABS_NAVBAR[currentRoute];
    this.SET_CURRENT_GKE_TAB(GKE_TABS[currentRoute] || GKE_TABS.NODE);
  },
};
</script>
<style lang="scss" scoped>
.cloud-menu {
  gap: 5rem;
}
.gke-container {
  flex: 1;
}
.line-separator {
  border: 0.03125em solid $line-separator;
  margin-top: 0.6875em;
  opacity: 80%;
  margin-bottom: 0.7em;
}
</style>
